import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { DtoExport, DtoImport } from '@core/utils/dto';
import { copyObjectProperties } from '@core/utils/object';
import { TipSourceSchema } from './tip-source.schema';
import { TipSourceConfig } from './tip-source-config';

export class TipSource implements Entity {
    public id: string;
    public label: string;
    public labelKey: string;
    public description: string;
    public descriptionKey: string;
    public available: boolean;
    public configurable: boolean;
    public config: TipSourceConfig;

    constructor(value?: any) {
        if (value) {
            copyObjectProperties.call(this, value);
        }
    }

    @DtoImport(TipSourceSchema)
    static import(dto: Dto): any {
        return new TipSource(dto);
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: TipSourceSchema,
        },
    ])
    export(type?: DtoType): any {}
}
